import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'gatsby';
import { Frame } from './styles';
import { Ja, En } from './svgs';
import { useLocation } from 'react-use';
import { getLocalizedPath } from '@src/utils/language-route';


const LangSwitch = props => {
	const { pathname } = useLocation();
	const currentPath = pathname || "/";

	return(
		<Frame>
			<Link to={ getLocalizedPath(currentPath, "ja") } className="lang__btn">
				<Ja style={{ fill: props.lang == "ja" ? "#9EB4CF" : "#FFF" }} />
			</Link>
			<span>/</span>
			<Link to={ getLocalizedPath(currentPath, "en") }  className="lang__btn">
				<En style={{ fill: props.lang == "en" ? "#9EB4CF" : "#FFF" }} />
			</Link>
		</Frame>
	)
}

const mapStateToProps = (state,props) => ({
	lang: state.langReducer.language,
})

export default connect(mapStateToProps)(LangSwitch)
